<script lang="ts">
	import { format } from '../services/i18n';
	import { Text, Button, Modal, Container } from '@Shelly/shelly-design-system';
	import { handleDeviceTurn } from 'src/helpers/handle_device_turn';
	import { doNotShowInitCalibrationModal, showCalibrationHasStartedModal } from 'src/stores/ui/calibration-modals';

	export let showModal = false,
		device;

	const updateCalibratingDevices = () => {
		showCalibrationHasStartedModal.update((state) => ({
			...state,
			device: null,
			visible: false,
		}));
		doNotShowInitCalibrationModal.set(true); //stop displaying the modal if a button is pressed, because in the socket we start to check from from 0 to 90 and visible: true is set multiple times to display the modal
	};

	const handleCloseModal = () => {
		showModal = false;
		updateCalibratingDevices();
	};

	const handleStopCalibratingDevice = async (e) => {
		await handleDeviceTurn({ device });
		handleCloseModal();
	};

	const handleCancel = () => {
		handleCloseModal();
	};
</script>

<Modal
	on:close={handleCancel}
	{showModal}
	title={$format('dimmer_calibration', {
		default: 'Dimmer calibration',
	})}
	backdropClose={false}
>
	<svelte:fragment slot="content">
		<Container slot="content" padding="0">
			<Text
				>{$format('dimmer_calibration_has_started', {
					default:
						"The calibration of your dimmer has begun. You have the option to wait for it to complete or to stop it. You can still control your lights even if the dimmer isn't calibrated. You can initiate the calibration at a later time.",
				})}</Text
			>
		</Container>
	</svelte:fragment>
	<div slot="footer" class="d-flex justify-content-end">
		<Button width="m" variant="secondary" class="mr-s" on:click={handleCancel}>
			{$format('button_ok', {
				default: 'ok',
			})}</Button
		>
		<Button
			width="m"
			on:click={(e) => {
				handleStopCalibratingDevice(e);
			}}
			>{$format('stop_calibration', {
				default: 'Stop calibration',
			})}</Button
		>
	</div>
</Modal>
